import { api } from "../api";

/**
 * findAllVehicleModelByBrandListResponse - Function that finds on database all vehicles model by brand as select list response   
 * /vehicles/models/{brandId}  
 * method GET 
 * @async-function
 */
const findAllVehicleModelByBrandListResponse = async (token: string, brandId: number) => {
    const response = await api.get(
        `/vehicles/models/${brandId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllVehicleModelByBrandListResponse;